<app-footer-sponsors></app-footer-sponsors>

<footer class="bg-primary text-white py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-12 col-lg-4">
        <address class="mb-3">
          Akademischer Sportverband Zürich<br />
          ETH Zürich<br />
          8092 Zürich <br />
          <a href="tel:+41446324210" class="text-white text-decoration-none">+41 44 632 42 10</a> <br />
          <a href="mailto:info@asvz.ch" class="text-white text-decoration-none">info&#64;asvz.ch</a> <br />
        </address>
      </div>

      <div class="col-12 col-lg-4 footer-divider">
        <h5 class="h6 fw-bold mb-3">Quicklinks</h5>
        <ul class="list-unstyled">
          <li class="mb-2">
            <a
              href="https://asvz.ch/59666-willkommen-im-asvz"
              target="_blank"
              rel="noopener"
              class="text-white text-decoration-none"
              >Member's Manual</a
            >
          </li>
          <li class="mb-2">
            <a
              href="https://asvz.ch/59443-teilnahmeberechtigung"
              target="_blank"
              rel="noopener"
              class="text-white text-decoration-none"
              >Teilnahme&shy;berechtigungen</a
            >
          </li>
        </ul>
      </div>

      <div class="col-12 col-lg-4 footer-divider">
        <h5 class="h6 fw-bold mb-3">Information</h5>
        <ul class="list-unstyled">
          <li class="mb-2">
            <a href="https://asvz.ch/avb" target="_blank" rel="noopener" class="text-white text-decoration-none">AVB</a>
          </li>
          <li class="mb-2">
            <a href="https://asvz.ch/login" target="_blank" rel="noopener" class="text-white text-decoration-none">FAQ</a>
          </li>
          <li class="mb-2">
            <a [routerLink]="'/impressum'" class="text-white text-decoration-none">Impressum</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="mt-3">
      <p class="small">© Copyright ASVZ. Alle Rechte vorbehalten.</p>
    </div>
  </div>
</footer>
